// packages
import { feature, mesh } from 'topojson-client';

/**
 *
 * @param {import('topojson-specification').Topology} topology
 * @param {string[]} keys
 * @returns
 */
export function topojsonToGeoJson(topology, keys) {
  const geojson = [];

  for (let idx = 0; idx < keys.length; idx++) {
    const key = keys[idx];
    const objects = topology.objects[key];

    const obj = {};

    obj['bounds'] = feature(topology, objects);
    obj['borders'] = mesh(topology, objects, (a, b) => a !== b);

    geojson.push(obj);
  }

  return geojson;
}
